// const VUE_APP_RESOURCE_URL = process.env.VUE_APP_RESOURCE_URL
export default{
    signIn: '/api-oauth/oauth/token',  // 登录
    validataUrl:'/api-exam-signup/signup/user/validata/code', // 获取验证码
    orgDataList: '/api-exam-signup/signup/user/org/list', // 获取学校
    sendCodeUrl: '/api-exam-signup/signup/user/sendCode', // 用户注册获取验证码
    addRegister: '/api-exam-signup/signup/user/register', // 注册
    loginUrl: '/api-exam-signup/signup/user/login', // 登陆
    forgetPwd: '/api-exam-signup/signup/user/forgetPwd', // 忘记密码
    getToken: '/api-oauth/oauth2/token', // 获取token
    getTime: '/api-exam-signup/signup/user/times', // 获取次数
    userMock: '/api-exam-signup/signup/user/mock', // 进入模拟
    userReal:'/api-exam-signup/signup/user/real', //进入考试
    fixedPhoto:'/api-exam-signup/signup/user/fixed/photo', // 重新上传img
    orgList: '/api-exam-signup/signup/user/apply/org/list', // 导出加载机构列表
    exportPhotoStatus: '/api-exam-signup/signup/check/exportPhoto/status', // 查血学生导出状态
    getScoreList: '/api-exam-signup/signup/user/getScoreList', // 查询成绩
    getExamList: '/api-exam-signup/signup/user/examPlan/list' // 查询考试列表

}